import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_e031
 * @category 일상점검항목등록 - 대분류
 */

export class DailyInspectionModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 점검종류
   *
   * **data type** varchar(5)
   */
  evlcd: string;

  /**
   * 구분코드
   *
   * **data type** varchar(5)
   */
  gevcd: string;

  /**
   * 구분명
   *
   * **data type** varchar(100)
   */
  gevnm: string;

  /**
   * 사용유무
   *
   * **data type** varchar(1)
   */
  useyn: string;

  /**
   * 비고
   *
   * **data type** varchar(255)
   */
  remark: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  indate: string;

  /**
   * 이름
   *
   * **data type** varchar(8)
   */
  evlnm: string;

  /**
   * 무한반복 제거를 위한 변수
   *
   *
   */
  new: string;

  isnew: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.evlcd = data.evlcd || '';
    this.gevcd = data.gevcd || '';
    this.gevnm = data.gevnm || '';
    this.useyn = data.useyn || '';
    this.remark = data.remark || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.evlnm = data.evlnm || '';
    this.new = data.new || '';
    this.isnew = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
